const FooterMenuData = [
  {
    title: "בית המדרש",
    url: "/BeitHamidrash",
  },
  {
    title: "התלמוד הממוזג",
    url: "/TalmudHaMemuzag",
  },
  {
    title: "צרו קשר",
    url: "/Contact",
  },
  {
    title: "מה חדש?",
    url: "WhatsNew",
  },
  {
    title: "אודות",
    url: "/About",
  },
  {
    title: "הוצאה לאור",
    url: "/Publishing",
  },
  {
    title: "תרומות",
    url: "/Terumot",
  },
  {
    title: "עמוד הבית",
    url: "/",
  },
];

export default FooterMenuData;
